import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageCancellationService } from './../services/messagecancellation.service';
import { Router } from '@angular/router';



@Component({
    templateUrl: './cancel-message-dialog.component.html',
    styleUrls: ['./cancel-message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CancelMessageDialogComponent implements OnInit {

  @Input() interchangeInIds: number[] = [];
  @Input() documentIds: number[] = [];
  @Input() interchangeOutIds: number[] = [];


  title: string;
  messagesCancelled: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private messageCancellationService: MessageCancellationService,
    private router: Router,) {
  }

  ngOnInit(): void {
    const totalMessageCount = this.interchangeInIds.length + this.documentIds.length + this.interchangeOutIds.length;
    this.title = (totalMessageCount < 2) ? 'Cancel message' : `Cancel ${totalMessageCount} messages`;
  }

  hasMessagesBeenCancelled(): boolean {
    return this.messagesCancelled;
  }

  cancelMessage(): void {
    this.messageCancellationService.cancelMessages(this.interchangeInIds, this.documentIds, this.interchangeOutIds);
    this.messagesCancelled = true;
    
  }

  goToCancelledMessages(): void {
    this.router.navigate(['/tracking/cancelmessagestatus']);
    this.activeModal.close();
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
